import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { Color } from 'src/app/utils/color.enum';
import { IBtnEvento } from 'src/app/custom-components/interfaces/btn-evento.interface';
import { IBtn } from 'src/app/custom-components/interfaces/btn.interface';
import { AplicacionVersionService } from 'src/app/_module/procesadora/aplicacion-datos/aplicacion-version/aplicacion-version.service';
import { DialogComponent } from 'src/app/custom-components/dialog/dialog.component';
import { DialogTipo } from 'src/app/custom-components/dialog/utils/dialog-type.enum';
import {MatDialog, MatDialogConfig, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DialogConfig } from 'src/app/custom-components/dialog/interfaces/dialog-config.interface';
import {Listas} from 'src/app/_helpers/clases/listas';
import {AplicacionVersion} from 'src/app/_models/aplicacion-version';
import {PageHeaderDataService} from 'src/app/shared/services/page-header-data.service';
import {PageHeaderData} from 'src/app/shared/components/forms-header/page-header-data';


/**
  * Listado de las versiones de las aplicaciones utilizadas.
  * @author Alejandro Planas
  */
@Component({
  selector: 'app-aplicacion-version-list',
  templateUrl: './aplicacion-version-list.component.html',
  styleUrls: ['./aplicacion-version-list.component.scss'],
})
export class AplicacionVersionListComponent extends Listas<AplicacionVersion> implements OnInit {
  tableColumns = [{name: 'Version', val: 'version'}, {name: 'Descripcion', val: 'descripcion'}, {name: 'Activo', val: 'activo'},{name: 'Aplicacion', val: 'aplicacion', nested: 'nombre', colSort: 'aplicacion_id'}];

  constructor(
    public router: Router,
    public service: AplicacionVersionService,
    public dialog: MatDialog,
    private headerDataService: PageHeaderDataService
  ) {
    super(router, 'procesadora/aplicacion_version', service, dialog);
  }

  ngOnInit(): void {
    this.headerDataService.setHeaderData(new PageHeaderData('Versión de Aplicación', this.rutaPadre + '/registrar', false, true));
  }


}
